







import Vue from 'vue';
// import BootstrapVue from 'bootstrap-vue';
// import 'bootstrap-honoka/dist/css/bootstrap.css';
// import 'bootstrap-vue/dist/bootstrap-vue.css';
// Vue.use(BootstrapVue);
export default Vue.extend({});
